import { connect } from 'react-redux'
import React from 'react'
import Pricing from '../pages/pricing/Pricing'

const PricingPage = ({ params, location }) => (
  <div className='s_p_a'>
    <Pricing key='pricing' viewParams={{ ...params, query: location.query }} />
  </div>
)

export default connect()(PricingPage)
